<script>
   // TODO: disse må nok fin justeres
   export let boat;
   let dir = boat.Direction-90;
   let distance = boat.Distance/166.66666666666666
   let heading = boat.Course-90;
   let name = boat.Name;

function toRad (angle) {
  return angle * (Math.PI / 180);
}

   let x = Math.cos(toRad(dir))*distance 
   let y = Math.sin(toRad(dir))*distance
</script>

<g transform="translate({x} {y})">
		  <text
       xml:space="preserve"
       style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:5.09758568px;line-height:1.25;font-family:Arial;-inkscape-font-specification:Arial;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.0923394"
       id="text4647"><tspan
         sodipodi:role="line"
         id="tspan4645"
         x="92"
         y="94"
         style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:5.09758568px;font-family:Arial;-inkscape-font-specification:Arial;stroke-width:1.0923394">{name}</tspan></text>
	
    <g 
       id="g4637"
			 transform-origin="81.2 96.3"
       transform="
                  translate(18 3)
                           rotate({heading})
									scale(4)">
      <path
         style="fill:#0000ff;stroke:#000000;stroke-width:0.12285747px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 81.854163,95.963011 0.441767,0.75122 -0.825492,0.31218 -1.247035,-0.442574 0.454867,-0.449979 -0.07845,-0.610658 z"
         inkscape:connector-curvature="0"
         id="path4639"
         sodipodi:nodetypes="ccccccc" />
    </g>
   </g>
